import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Seo from '../../components/Seo';
import { getStaticMeta } from '../../seo/pageMeta';

const PrivacyScreen = () => {
  const { t, i18n } = useTranslation();
  const meta = getStaticMeta('privacy', i18n.language);

  return (
    <div className="min-h-screen bg-bg pt-28 pb-24 md:pt-32">
      <Seo title={meta.title} description={meta.description} path="/privacy" />
      <div className="mx-auto max-w-page px-6">
        <article className="max-w-3xl mx-auto prose prose-invert prose-headings:text-body prose-a:text-primary prose-p:text-muted prose-li:text-muted">
          <h1>{t('legal.privacyPolicy.title')}</h1>
          <p className="text-sm !text-muted">
            {t('legal.privacyPolicy.lastUpdated')}
          </p>

          <section>
            <h2>{t('legal.privacyPolicy.sections.introduction.title')}</h2>
            <p>{t('legal.privacyPolicy.sections.introduction.content1')}</p>
            <p>{t('legal.privacyPolicy.sections.introduction.content2')}</p>
          </section>

          <section>
            <h2>{t('legal.privacyPolicy.sections.dataCollection.title')}</h2>
            <p>{t('legal.privacyPolicy.sections.dataCollection.content1')}</p>
            <ul>
              {t('legal.privacyPolicy.sections.dataCollection.list', { returnObjects: true }).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          <section>
            <h2>{t('legal.privacyPolicy.sections.dataUse.title')}</h2>
            <p>{t('legal.privacyPolicy.sections.dataUse.content1')}</p>
            <ul>
              {t('legal.privacyPolicy.sections.dataUse.list', { returnObjects: true }).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          <section>
            <h2>{t('legal.privacyPolicy.sections.dataSharing.title')}</h2>
            <p>{t('legal.privacyPolicy.sections.dataSharing.content1')}</p>
            <p>{t('legal.privacyPolicy.sections.dataSharing.content2')}</p>
            <ul>
              {t('legal.privacyPolicy.sections.dataSharing.list', { returnObjects: true }).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          <section>
            <h2>{t('legal.privacyPolicy.sections.dataRetention.title')}</h2>
            <p>{t('legal.privacyPolicy.sections.dataRetention.content1')}</p>
            <p>{t('legal.privacyPolicy.sections.dataRetention.content2')}</p>
            <ul>
              {t('legal.privacyPolicy.sections.dataRetention.list', { returnObjects: true }).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          <section>
            <h2>{t('legal.privacyPolicy.sections.rights.title')}</h2>
            <p>{t('legal.privacyPolicy.sections.rights.content1')}</p>
            <ul>
              {t('legal.privacyPolicy.sections.rights.list', { returnObjects: true }).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            <p className="!text-primary font-medium">
              {t('legal.privacyPolicy.sections.rights.content2')}
            </p>
          </section>

          <section>
            <h2>{t('legal.privacyPolicy.sections.security.title')}</h2>
            <p>{t('legal.privacyPolicy.sections.security.content1')}</p>
            <ul>
              {t('legal.privacyPolicy.sections.security.list', { returnObjects: true }).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          <section>
            <h2>{t('legal.privacyPolicy.sections.cookies.title')}</h2>
            <p>{t('legal.privacyPolicy.sections.cookies.content1')}</p>
            <p>
              {t('legal.privacyPolicy.sections.cookies.content2')}{' '}
              <Link to="/cookies">Politique de cookies</Link>.
            </p>
          </section>

          <section>
            <h2>{t('legal.privacyPolicy.sections.contact.title')}</h2>
            <p>{t('legal.privacyPolicy.sections.contact.content1')}</p>
            <p className="!text-primary font-medium">
              {t('legal.privacyPolicy.sections.contact.email')}
            </p>
            <p className="text-sm !text-muted">
              {t('legal.privacyPolicy.sections.contact.address')}
            </p>
          </section>

          <div className="pt-8 border-t border-white/10 not-prose flex justify-between">
            <Link to="/legal" className="text-primary hover:text-primary-light transition-colors">
              ← Mentions légales
            </Link>
            <Link to="/terms" className="text-primary hover:text-primary-light transition-colors">
              Conditions d'utilisation →
            </Link>
          </div>
        </article>
      </div>
    </div>
  );
};

export default PrivacyScreen;
